function comparePerms(permToCheck, permToCheckAgainst) {
  // permToCheck could be "chat.read", and permToCheckAgainst could be "chat.*"
  // This would then return true.

  for (var i = 0; i < permToCheck.length; i++) {
    if (permToCheck[i] != permToCheckAgainst[i]) {
      // The segments do not match...

      if (i == permToCheck.length - 1) {
        // Only if this is the last item:
        // This segment doesn't match. Check if it's a wildcard, in which case it covers everything immediately under it.
        if (permToCheckAgainst[i] == '*') return true;
        else return false;
      } else {
        // This is not the last item, and the segment did not match.
        // aka we are trying to match chat.admin.delete against room.inviteGuests
        return false;
      }
    }
  }

  // All match - return true
  return true;
}

function split(perms) {
  const permsSplit = perms.split('.');
  return permsSplit;
}

export function isAllowed(permToCheck, permissionObject) {
  permToCheck = split(permToCheck);
  let result = false;

  for (const key in permissionObject) {
    const permToCheckAgainst = split(key);

    if (comparePerms(permToCheck, permToCheckAgainst)) {
      result = permissionObject[key];

      // We intentionally don't break here, so that if multiple permissions match, the last one wins.
    }
  }

  // No matching perms, not allowed
  return !!result;
}
